import stressFeatures from '@/app/[locale]/stress/_data/stressFeatures';
import stressFeaturesGradients from '@/app/[locale]/stress/_data/stressFeaturesGradients';
import LandingPageFeatures from '@/app/components/LandingPage/LandingPageFeatures';

const StressFeatures = () => {
  return (
    <LandingPageFeatures
      data-cy="stress-features"
      eyebrow="explore_features"
      features={stressFeatures}
      imageGradientBg={{
        className: 'bg-[#605570]',
        gradients: stressFeaturesGradients,
      }}
      textColor="purple-700"
    />
  );
};
export default StressFeatures;
